import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { MonitoringRoutingService } from '../../../Core/services/monitoring-routing.service';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { userPermissionsEnum } from '../../../../Core/Users/enums/user-permissions.enum';
import { MonitoringQuotaTypesEnum } from '../../../../api/mentions/enum/monitoring-quota-types.enum';


@Component({
    selector: 'agpr-subscription-dashboard',
    templateUrl: './subscription-dashboard.component.html',
    styleUrls: ['./subscription-dashboard.component.scss'],
    standalone: false
})
export class SubscriptionDashboardComponent implements OnInit, OnDestroy {

    readonly quotaType = MonitoringQuotaTypesEnum.MEDIA_SUBSCRIPTION;

    mediaSubscriptionsProvisioned: boolean = false;

    private subscriptions: Subscription[] = [];

    constructor(
        private monitoringRoutingService: MonitoringRoutingService,
        private userStateService: CurrentUserStateService
    ) {}

    ngOnInit() {
        this.subscriptions.push(
            this.userStateService.hasAnyPermissions([userPermissionsEnum.mediaSubscriptions]).subscribe(
                (provisioned) => {
                    this.mediaSubscriptionsProvisioned = provisioned;

                    // If media subscriptions are not provisioned to the account, the user shouldn't be here, so go to the hype page.
                    if (this.mediaSubscriptionsProvisioned === false) {
                        this.monitoringRoutingService.gotoSubscriptionHype();
                    }
                }
            )
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
